// React
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

// Contants
import { ROUTES_CONSTANTS } from "../../constants/routesConstants";

// Utils
import { getCookie, removeCookie } from "../../utils/CookiesUtil";

const ProtectedRoute = ({ children }) => {

  const accessToken = getCookie("accessToken");

  const handleLogout = () => {
    removeCookie("role");
    removeCookie("accessToken");
  };

  if (!accessToken) {
    handleLogout();
    return <Navigate to={ROUTES_CONSTANTS.LOGIN} />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
